import { configureStore } from '@reduxjs/toolkit';
import userManagementReducer from '../features/usermanagement/usermanagementSlice';

export const store = configureStore({
  reducer: {
    usermangement: userManagementReducer
  },
});
